<template>
  <div class="popup__block">
    <div class="popup__close"></div>
    <div class="popup__title">Ваш отзыв</div>
    <div class="popup-review">
      <form @submit.prevent="debounce(validate)" class="form">
        <div class="form__inputs">
          <div class="custom-input">
            <input @input="this.reset" v-model="name" autocomplete="off" class="custom-input__input" v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 4)}" type="text" placeholder="Введите ФИО">
            <span v-if="errors.some(er => er.code === 4)" class="custom-input__error"></span>
            <label class="custom-input__label">ФИО</label>
          </div>
          <div class="custom-input custom-input--file">
              <input class="custom-input__input" @change="fileChange($event)" :class="{'custom-input__input--error' : errors.some(er => parseInt(er.code) === 4)}" type="file" accept=".jpg,.gif,.bmp,.png,.jpeg,.webp">
              <label class="custom-input__label">Фото</label>
              <span v-if="errors.some(er => er.code === 4)" class="custom-input__error"></span>
              <span v-if="photoFile && photoFile.name" class="custom-input__placeholder active" >{{ photoFile.name }}</span>
          </div>
          <div class="default-textarea">
                            <textarea @input="this.reset" v-model="review" autocomplete="off" class="default-textarea__textarea" type="text" v-bind:class="{'default-textarea__textarea--error':errors.some(er => er.code === 8)}" placeholder="Напишите отзыв"></textarea>
            <span v-if="errors.some(er => er.code === 8)" class="default-textarea__error"></span>
          </div>
        </div>
        <div style="display: none">
          <vue-recaptcha ref="recaptcha" size="invisible" :sitekey="this.site_key" @verify="sendData" @expired="onCaptchaExpired"/>
        </div>
        <div class="form__submit">
          <input class="btn btn--mini" type="submit" value="Оставить отзыв"/>
          <div class="form__submit-text">Нажимая кнопку, Вы даете информированное согласие<br> на
            <a target="_blanc" :href="modulePolicy.file_src">обработку своих персональных данных</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import recaptcha from "@/components/mixins/recaptcha";
import errors    from "@/components/mixins/errors";
import tools     from "@/components/mixins/tools";
import {mapState} from "vuex";

export default {
  name  : "ReviewForm",
  props : {
    product : {
      type    : Number,
      default : 0
    }
  },
  data()
  {
    return {
      name   : "",
      review : "",
      photoFile: null,
    };
  },
  computed : {
    ...mapState([
      "modulePolicy"
    ])
  },
  mixins   : [recaptcha, errors, tools],
  methods  : {
    sendData( recaptchaToken )
    {
      this.reset();
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("review", this.review);
      formData.append('photo', this.photoFile);
      formData.append("product", this.product.toString());
      formData.append("token", recaptchaToken);
      fetch("/api/reviews/add/", {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(async resp =>
      {
        if(resp.success !== true)
        {
          let errs = JSON.parse(resp.message);
          this.parse(errs);
        }
        else
        {
          window.toast.success("Спасибо за ваш отзыв!", "Он появится на странице после модерации.");
          this.name   = "";
          this.review = "";
          window.popup.close("#review");
        }
      });
    },
    fileChange( event )
    {
      if((event.target.files[0].size / 1024 / 1024) < 30)
      {
        this.photoFile = event.target.files[0];
      }
      else
      {
        event.target.value = null;
        window.toast.error("Размер файла не может превышать 30 Мб");
      }
    },
  }
};
</script>

<style scoped>

</style>
